export const getGeneralLedgerCodesImportConfig = () => {
  const fields = [
    {
      label: "G/L Code",
      key: "code",
      type: "string",
      validators: [
        { validate: "required" },
        {
          validate: "unique_case_insensitive",
          error: "Duplicate G/L code in import",
        },
      ],
    },
  ]

  return { fields }
}
